module.exports = __webpack_public_path__ + "static/img/employee-03.a6eb7d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/community/employee-03.png
// module id = L+pY
// module chunks = 2